// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__sN5Ey","buscador":"Formulario_buscador__2ABO4","btn_block":"Formulario_btn_block__3xO29","title":"Formulario_title__2HaUb"};